import { Stack, styled, Typography } from '@mui/material';
import { LayoutNoAuth } from 'app/components/templates/LayoutNoAuth';
import { StyledParams } from 'types/common';
import { ButtonCustom } from 'app/components/elements/ButtonCustom';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useSystemInfo } from 'contexts/systemInfo';

export const ResetPasswordSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const { systemInfo } = useSystemInfo();
  const navigate = useNavigate();
  return (
    <LayoutNoAuth>
      <Wrapper>
        <Stack
          pt={{ xs: 4, md: 8.375 }}
          pb={3.5}
          width={'100%'}
          alignItems={'center'}
          minHeight={'100vh'}>
          <Stack
            px={{ xs: 3.125, sm: 0 }}
            mt={3}
            width={'100%'}
            maxWidth={{ xs: 'unset', sm: 402 }}>
            <Stack
              width={'100%'}
              alignItems={'center'}
              gap={{ xs: 3, md: 7.25 }}
              mb={{ xs: 15, md: 33.75 }}>
              {systemInfo?.logoUrl && <img alt={'logo'} width={96} src={systemInfo?.logoUrl} />}
              <Stack gap={2} width={'100%'} alignItems={'center'}>
                <TextTitleStyled>Reset Password</TextTitleStyled>
                <TextDescStyled>
                  {
                    'Your password has been updated successfully.\n Please login again to access your account.'
                  }
                </TextDescStyled>
              </Stack>
            </Stack>
            {searchParams.get('platform') !== 'app' && (
              <Stack gap={3.25}>
                <ButtonCustom onClick={() => navigate('/login')} label={'Back to Login'} />
              </Stack>
            )}
          </Stack>
        </Stack>
      </Wrapper>
    </LayoutNoAuth>
  );
};

const Wrapper = styled(Stack)(() => ({
  height: '100vh',
  overflowY: 'scroll'
}));
const TextTitleStyled = styled(Typography)(({ theme }: StyledParams) => ({
  fontSize: '32px',
  fontWeight: '700',
  color: theme.colors.base,
  textAlign: 'center'
}));
const TextDescStyled = styled(Typography)(({ theme }: StyledParams) => ({
  fontSize: '14px',
  fontWeight: '700',
  color: theme.colors.base,
  textAlign: 'center',
  whiteSpace: 'pre-line'
}));
